import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject } from 'rxjs';
import { IPayloadToken } from 'src/app/interfaces/Global/PayloadToken';
import { getCurrentDateInMilliseconds, getCurrentUTCTimestamp } from 'src/app/utils/Date';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  public remainingTime$ = new BehaviorSubject<number>(0);
  private intervalId: any;

  constructor() {}

  public setTimer(time: number, onExpired: () => void): void {
    // Un solo intervalo vivo. El resolver de la inspección llama acá cada vez que se entra a
    // /inspection: sin esto el intervalo anterior sigue restando sobre el mismo reloj, que corre al
    // doble, y como stopTimer ya no lo alcanza, termina venciendo la inspección por su cuenta.
    this.stopTimer();
    this.remainingTime$.next(time);
    this.intervalId = setInterval(() => {
      const remainingTime = this.remainingTime$.value;
      if (remainingTime > 0) {
        this.remainingTime$.next(remainingTime - 1000);
      } else {
        onExpired();
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  public stopTimer(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  public getRemainingTimeFromToken(token: string): number {
    const payload = jwtDecode<IPayloadToken>(token);
    const endDate = parseInt(payload.end_date);
    const now = getCurrentDateInMilliseconds();;
    return Math.max(0, endDate - now);
  }
}
